// Listing covers can be absolute (link previews, stock) or our own
// "/api/previews/…" teaser snapshots, which need the backend origin
// (the Android bundle is not served from the backend host).
export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const ProductCover = ({ p, className = "h-full w-full object-cover" }) => (
  <img
    src={mediaUrl(p.image_url)}
    alt=""
    data-blur={p.preview_blur ? "true" : undefined}
    className={`${className} ${p.preview_blur ? "blur-[3px] scale-110" : ""}`}
  />
);
